import React from 'react';
import { Chart } from 'primereact/chart';
import { Skeleton } from 'primereact/skeleton';
import styles from './BarChart.module.scss';
import useTenantStore from '../../../../stores/TenantStore';

const CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  categoryPercentage: 1.0,
  barPercentage: 0.85,
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      anchor: 'end',
      align: 'top',
      rotation: 270,
      formatter: Math.round,
      color: '#70707B',
    },
  },
  label: {
    display: false,
  },
  scales: {
    y: {
      display: false,
      beginAtZero: true,
      min: 0,
      max: 115,
    },
    x: {
      display: false,
      beginAtZero: true,
    },
  },
};

interface IBarChartProps {
  label: string;
  lastWeek: number;
  monthToDate: number;
  lastMonth: number;
  yearToDate: number;
  loading?: boolean;
}

const BarChart: React.FC<IBarChartProps> = ({
  label,
  lastWeek,
  monthToDate,
  lastMonth,
  yearToDate,
  loading,
}) => {
  const data = useTenantStore();
  const chartData = React.useMemo(
    () => ({
      datasets: [
        {
          data: [lastWeek, monthToDate, lastMonth, yearToDate],
          backgroundColor: [
            data.appColors?.find((c) => c.type === 'P400')?.value ?? 'black',
            data.appColors?.find((c) => c.type === 'P500')?.value ?? 'black',
            data.appColors?.find((c) => c.type === 'P300')?.value ?? 'black',
            data.appColors?.find((c) => c.type === 'P200')?.value ?? 'black',
          ],
          borderRadius: 2,
        },
      ],
      labels: ['', '', '', ''],
    }),
    [
      data.appColors?.find((c) => c.type === 'P500')?.value,
      data.appColors?.find((c) => c.type === 'P300')?.value,
      data.appColors?.find((c) => c.type === 'P200')?.value,
      data.appColors?.find((c) => c.type === 'P400')?.value,
      lastMonth,
      lastWeek,
      monthToDate,
      yearToDate,
    ],
  );

  return (
    <div className={styles.container}>
      <span className={styles.label}>{label}</span>

      {loading ? (
        <>
          <Skeleton
            width="2rem"
            height="21rem"
            borderRadius="2px"
            className="mr-1"
          />
          <Skeleton
            width="2rem"
            height="23rem"
            borderRadius="2px"
            className="mr-1"
          />
          <Skeleton
            width="2rem"
            height="14rem"
            borderRadius="2px"
            className="mr-1"
          />
          <Skeleton
            width="2rem"
            height="18rem"
            borderRadius="2px"
            className="mr-1"
          />
        </>
      ) : (
        <Chart
          className="w-[9rem] h-[25rem]"
          type="bar"
          data={chartData}
          options={CHART_OPTIONS}
        />
      )}
    </div>
  );
};

export default BarChart;
